<template>
  <div>
    <section>
      <first-header />
    </section>
    <article class="container sliderContainer">
      <slider />
    </article>
    <section>
      <second-menu />
    </section>
    <section>
      <card-home />
    </section>
    <news />
    <section>
      <div class="container" v-if="subdomain !== 'sekretariati'">
        <div class="row">
          <!-- <h3 class="text-center title-report">Periudha e raportimit - 2024</h3> -->
          <title-area :title="$t('raporti_grafikonet.title')" />
          <div class="col-lg-8">
            <graphics-show />
          </div>
          <div class="col-lg-4">
            <calendar />
          </div>
        </div>
      </div>
    </section>
    <section class="report" v-if="subdomain !== 'sekretariati' && subdomain !== 'kpk'">
      <raporti24h  />
    </section>
    <buletin-view v-if="subdomain !== 'sekretariati'"/>
    <section>
      <AllCases />
      <completencies />
    </section>
  </div>
</template>

<script>
import Slider from '../components/layout/SliderVue.vue';
import CardHome from '../components/layout/CardHome.vue';
import News from '../components/layout/NewsSection.vue';
import Raporti24h from '../components/layout/RaportState.vue'
import GraphicsShow from '../components/layout/GraphicsShow.vue'
import Calendar from '../components/layout/CalendarView.vue'
import AllCases from '@/components/layout/AllCases.vue';
import secondMenu from '@/components/share/SecondMenu.vue';
import buletinView from '@/components/layout/BuletinView.vue';
import completencies from '../Prokurorit/share/CompetenciesView.vue'; 
import titleArea from '../components/share/TitleArea.vue';
import firstHeader from '../components/share/FirstHeader.vue'

export default {
  data(){
    return{
      subdomain: ''
    }
  },
  mounted(){
    this.subdomain = this.getSubdomain();
  },
  methods:{
    getSubdomain() {
      const host = window.location.hostname; // p.sh. "kpk.localhost"
      if (host.includes('.')) {
        return host.split('.')[0]; // Merr pjesën para pikës
      }
      return ''; // Nëse nuk ka nën-domen, kthe bosh
    }
  },
  components: {
    Slider,
    CardHome,
    News,
    GraphicsShow,
    Calendar,
    Raporti24h,
    AllCases,
    secondMenu,
    buletinView,
    completencies,
    titleArea,
    firstHeader
  },
};
</script>

<style scoped>
section {
  margin-top: 10px;
  margin-bottom: 10px;
}

.title-report {
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.01em;
  color: #101828;
}

.report {
  background-color: #eff2f5;
  padding: 48px 0;
}

.contact {
  background-color: #eff2f5;
  margin-bottom: 0 !important;
}

.subscribe {
  background-color: #243652;
  padding: 48px 0;
  margin: 0;
}

.footer {
  background-color: #2c3f5e;
  color: white;
}

@media(max-width: 575.98px) {
  .sliderContainer{
    padding:0 !important;
  }
}
</style>